import config from 'constants/apiConfig';
import axios from 'axios';
import {
  GET_ALL_BRANCH,
  GET_ALL_DIVISION,
  GET_PLANNING_WORKSHEET,
} from 'constants/form-action-types';
import generateUUID from 'utils/sharedUtils/generateUUID';
import { endLoading, startLoading } from 'reducers/loading/loading.action';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

function parseError(api) {
  const errorMessage =
    `${api}` +
    'Unable to delete as there are associated data. ' +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
}

export const getPlanningWorksheet = () => {
  return (dispatch, getState) => {
    dispatch(startLoading());
    return axios(config.apiGateway.getPlanningWorksheet, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
        operational_period_id: getState().app.currentIncident.current_period,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_PLANNING_WORKSHEET, payload: response.data });
        dispatch(endLoading());
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.getPlanningWorksheet, error));
        dispatch(endLoading());
      });
  };
};


export const upsertPlanningWorksheet = (type, data) => {
  return (dispatch, getState) => {
    const planningWorksheet = {
      ...getState().app.planningWorksheet,
      id: getState().app.planningWorksheet?.id
        ? getState().app.planningWorksheet.id
        : generateUUID(),
      operational_period_id: getState().app.currentIncident.current_period,
      prepared_by_guid: getState().app.user.user_guid,
    };

    if (type === 'Branch') {
      planningWorksheet.branch_id = data;
      planningWorksheet.division_id = null;
    }
    if (type === 'Division') {
      planningWorksheet.division_id = data;
    }
    if (type === 'Special Instructions') {
      planningWorksheet.form_special_instructions = data;
    }
    if (type === 'Emergency Communications') {
      planningWorksheet.medical_comm = data.medical_comm;
      planningWorksheet.evacuation_comm = data.evacuation_comm;
      planningWorksheet.other_comm = data.other_comm;
    }
    if (type === 'ReviewedByOSC') {
      planningWorksheet.osc_reviewed_by = data ? data.user_guid : null;
      planningWorksheet.osc_reviewed_date_time = data
        ? dayjs().toDate()
        : null;
    }
    if (type === 'ReviewedByPSC') {
      planningWorksheet.psc_reviewed_by = data ? data.user_guid : null;
      planningWorksheet.psc_reviewed_date_time = data
        ? dayjs().toDate()
        : null;
    }
    return axios(config.apiGateway.upsertPlanningWorkSheets, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
        planningWorksheet,
      }),
    })
      .then(() => {
        dispatch(getPlanningWorksheet());
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.upsertPlanningWorkSheets, error));
      });
  };
};

export const getAllBranch = () => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.getAllBranch, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_ALL_BRANCH, payload: response.data });

        dispatch(endLoading());
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.getAllBranch, error));
      });
  };
};

export const upsertBranch = (branch) => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.upsertBranch, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
        branch,
      }),
    })
      .then(() => {
        dispatch(getAllBranch());
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.upsertBranch, error));
        dispatch(endLoading());
      });
  };
};

export const deleteBranch = (branch_id) => (dispatch, getState) =>
  axios(config.apiGateway.deleteBranch, {
    method: 'POST',
    data: JSON.stringify({
      group_guid: getState().app.currentlySelectedGroup.group_guid,
      branch_id,
    }),
  })
    .then(() => {
      dispatch(getAllBranch());
      dispatch(getPlanningWorksheet());
    })
    .catch((error) => {
      dispatch(endLoading());
      dispatch(parseError(config.apiGateway.deleteBranch, error));
    });

export const getAllDivision = (branch_id) => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.getAllDivision, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
        branch_id,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_ALL_DIVISION, payload: response.data });

        dispatch(endLoading());
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.getAllDivision, error));
      });
  };
};

export const getAllDivisionByGroupId = () => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.getAllDivisionByGroupId, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
      }),
    })
      .then((response) => {
        dispatch({ type: GET_ALL_DIVISION, payload: response.data });

        dispatch(endLoading());
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.getAllDivision, error));
      });
  };
};

export const upsertDivision = (division, from = '', branch_id) => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.upsertDivision, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
        division,
      }),
    })
      .then(() => {
        if (from === 'getAll') {
          dispatch(getAllDivisionByGroupId());
        } else if (branch_id) {
          dispatch(getAllDivision(branch_id));
        } else {
          dispatch(getAllDivision(division?.branch_id));
        }
      })
      .catch((error) => {
        dispatch(parseError(config.apiGateway.upsertDivision, error));
        dispatch(endLoading());
      });
  };
};

export const deleteDivision = (division_id, branch_id, from) => {
  return (dispatch, getState) => {
    return axios(config.apiGateway.deleteDivision, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: getState().app.currentlySelectedGroup.group_guid,
        division_id,
      }),
    })
      .then(() => {
        if (from === 'getAll') {
          dispatch(getAllDivisionByGroupId());
        } else {
          dispatch(getAllDivision(branch_id));
        }
        dispatch(endLoading());
        dispatch(getPlanningWorksheet());
      })
      .catch((error) => {
        dispatch(endLoading());
        dispatch(parseError(config.apiGateway.deleteDivision, error));
      });
  };
};
